import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/bom-families-create.mdx";

export function BomFamiliesCreateHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
